import common from './common'
const messageCenterOperateKfmt =
  'duba_jgpdf_huiyuan_xiaoxi:8396 shows:byte clicks:byte'

export default {
  REPORT: {
    /**
     * 上报消息中心的操作
     * @param {*} params
     * @description click=1，点击关闭消息页面；click=2，点击关闭某一条消息页面；click=3，点击跳转到自动续费
     * @returns
     */
    reportMessageCenterOperate (params) {
      const info = {
        shows: 0,
        clicks: 0,
      }
      return common.REPORT.client_report_by_kfmt(
        messageCenterOperateKfmt,
        common.API.replaceObj(info, params)
      )
    },
    /**
     * 上报消息中心展示
     * @param {*} params
     * @returns
     */
    reportMessageCenterShow (params) {
      const info = {
        shows: 1,
        clicks: 0,
      }
      return common.REPORT.client_report_by_kfmt(
        messageCenterOperateKfmt,
        common.API.replaceObj(info, params)
      )
    },
  },
}
